import { render, staticRenderFns } from "./RegionEditView.vue?vue&type=template&id=3d1cf7fd&scoped=true&"
import script from "./RegionEditView.vue?vue&type=script&lang=js&"
export * from "./RegionEditView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1cf7fd",
  null
  
)

export default component.exports